import React, {Component} from "react";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  Radio,
  InputGroup,
  Button,
  OverlayTrigger,
  Popover
}                         from "react-bootstrap";
import Select             from "react-select";
import DateTime           from "react-dateTime";
import                         "style/react-datetime.css";
import moment             from "moment";
import Dropzone           from "react-dropzone";

import { IS_VALID }       from "utils";

import ic_calendar        from "../../../assets/image/ic_calendar.svg";

export default class Update extends Component {
  constructor (props) {
    super(props);

    this.dropzoneRef;

    this.state = {
      isOpenDatePicker: false
    };
  }

  render () {
    let {
      isOpenDatePicker
    } = this.state;

    let {
      reduxStateName,
      actions,

      loadOptions,
      uploadUserCSVFile,

      isScheduled
    } = this.props;

    let {
      isUploadingCSVFile,

      sendMode,
      sendModeOptions,
      userType,
      userTypeOptions,
      cardType,
      cardTypeOptions,
      device,
      deviceOptions,
      screen,
      screenOptions,
      browser,
      browserOptions,

      subject,
      url,
      message,
      isSendNow,
      scheduleDateTimeNotif,

      specificUser,
      specificUserOptions,
      blacklistedUser,
      blacklistedUserOptions
    } = this.props[reduxStateName];

    let {
      setValue
    } = actions;

    const space = {
      paddingTop: '10px',
      paddingBottom: '10px'
    };

    const colorBlack = {
      color: 'black'
    };

    let requiredSpan = <span style={{ color: "red" }}>*</span>;

    let isCardTypeFieldDisabled = specificUser.length !== 0 ? true : false,
        isSpecificUserFieldDisabled = cardType.length !== 0 ? true : false;

    let popupMessage = (component, message) => {
      return (
        <OverlayTrigger
          placement="top"
          id={message}
          overlay={
            <Popover>
              {message}
            </Popover>
          }
          >
          {component}
        </OverlayTrigger>
      );
    };

    let disabledSendNow = IS_VALID(isScheduled) ? isScheduled : false;
    
    return (
      <div>
        <Row>
          <Col md={6}>
            <h4>Mobile Users</h4>
            <Row style={space}>
              <Col md={4}>Send Mode</Col>
              <Col md={8}>
                <Select
                    clearable={false}
                    value={sendMode}
                    options={sendModeOptions}
                    onChange={e => {
                      let stateToUpdate = {
                        sendMode: e
                      };

                      if (e.value.toUpperCase() === "TEST") {
                        stateToUpdate.userType = {
                          value: "MEMBER",
                          label: "MEMBER"
                        };
                      } else {
                        stateToUpdate.userType = {
                          value: 'ALL',
                          label: 'ALL'
                        };

                        stateToUpdate.cardType = [];
                        stateToUpdate.specificUser = [];
                      }

                      setValue(stateToUpdate);
                    }}
                  />
              </Col>
            </Row>
            <Row style={space}>
              <Col md={4}>User Type</Col>
              <Col md={8}>
                <Select
                  clearable={false}
                  disabled={sendMode.value.toUpperCase() === "TEST"}
                  value={userType}
                  options={userTypeOptions}
                  onChange={e => {
                    let stateToUpdate = {
                      userType: e
                    };

                    if (e.value !== "MEMBER") {
                      stateToUpdate.cardType = [];
                      stateToUpdate.specificUser = [];
                    }

                    setValue(stateToUpdate);
                  }}
                />
              </Col>
            </Row>
            {IS_VALID(userType) && IS_VALID(userType.value) && userType.value === "MEMBER" ? (
              <Row style={space}>
                <Col md={4}>
                  Card Holder Type&nbsp;
                  {isCardTypeFieldDisabled ? (
                    popupMessage(
                      <i className="fa fa-info-circle"></i>,
                      "Specific User is already assigned"
                    )
                  ) : (
                    ""
                  )}
                </Col>
                <Col md={8}>
                  <Select.Async
                    placeholder="Select or Search..."
                    multi={true}
                    disabled={isCardTypeFieldDisabled}
                    value={cardType}
                    loadOptions={(input, callback) => loadOptions(input, callback, 'CardType', 'name', cardTypeOptions)}
                    onChange={(value) => setValue({ cardType: value })}
                    />
                </Col>
              </Row>
            ) : (
              ""
            )}
            <Row style={space}>
              <Col md={4}>Device Type</Col>
              <Col md={8}>
                <Select
                  clearable={false}
                  value={device}
                  options={deviceOptions}
                  onChange={(value) => setValue({ device: value })}
                  />
              </Col>
            </Row>
            <Row style={space}>
              <Col md={4}>Screen</Col>
              <Col md={8}>
                <Select.Async
                  placeholder="Select or Search..."
                  value={screen}
                  loadOptions={(input, callback) => loadOptions(input, callback, 'Screen', 'pageName', screenOptions)}
                  onChange={(value) => setValue({screen: value })}
                  />
              </Col>
            </Row>
            <Row style={space}>
              <Col md={4}>Browser</Col>
              <Col md={8}>
                <Select
                  value={browser}
                  options={browserOptions}
                  onChange={(value) => {
                    let stateToUpdate = {
                      browser: value
                    };

                    if (!IS_VALID(value)) {
                      stateToUpdate.url = "";
                    }

                    setValue(stateToUpdate);
                  }}
                  />
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <h4>Push Notification Details</h4>
            <Row>
              <Col md={12}>
                <FormGroup>
                  Subject {requiredSpan}
                  <FormControl
                    type="text"
                    placeholder="Enter Subject.."
                    value={subject}
                    onChange={(e) => setValue({ subject: e.target.value })}
                    inputRef={e => (this.subject = e)}
                    style={colorBlack}
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  Url Link {requiredSpan}
                  <FormControl
                    type="text"
                    placeholder="Enter Url.."
                    value={url}
                    onChange={(e) => setValue({ url: e.target.value })}
                    inputRef={e => (this.url = e)}
                    style={colorBlack}
                    disabled={IS_VALID(browser) ? null : "disabled"}
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  Notification Message {requiredSpan}
                  <FormControl
                    componentClass="textarea"
                    placeholder="Enter Message.."
                    value={message}
                    onChange={(e) => setValue({ message: e.target.value })}
                    inputRef={e => (this.message = e)}
                    style={colorBlack}
                  />
                </FormGroup>
                <FormGroup>
                  <Radio
                    name="pushtype"
                    inline
                    disabled={disabledSendNow}
                    checked={isSendNow}
                    onChange={e => {
                      if (!disabledSendNow) {
                        setValue({ isSendNow: true, scheduleDateTimeNotif: "" })
                      }
                    }}
                  >
                    Send Push
                  </Radio>
                </FormGroup>
                <FormGroup>
                  <Radio
                    name="pushtype"
                    inline
                    checked={!isSendNow}
                    onChange={e => setValue({ isSendNow: false })}
                  >
                    Schedule Push Notification
                  </Radio>
                </FormGroup>
                <FormGroup>
                  <InputGroup>
                    <DateTime
                      dateFormat="MMM DD, YYYY"
                      timeFormat="hh:mm A"
                      value={scheduleDateTimeNotif}
                      inputProps={{
                        disabled: isSendNow
                      }}
                      disableOnClickOutside={true}
                      onBlur={() => {
                        this.setState({ isOpenDatePicker: false });
                      }}
                      open={isOpenDatePicker}
                      onChange={(value) => {
                        setValue({ scheduleDateTimeNotif: value });
                      }}
                      style={colorBlack}
                      isValidDate={current => {
                        return current.isAfter(moment().subtract(1, "day"));
                      }}
                      />
                    <InputGroup.Button>
                      <Button
                        disabled={isSendNow}
                        style={{
                          backgroundColor: "black",
                          paddingTop: "0",
                          paddingBottom: "0"
                        }}
                        onBlur={() => {
                          this.setState({ isOpenDatePicker: false });
                        }}
                        onClick={() => {
                          this.setState({ isOpenDatePicker: !isOpenDatePicker });
                        }}
                        >
                        <img src={ic_calendar} height="32px" />
                      </Button>
                    </InputGroup.Button>

                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          {IS_VALID(userType) && IS_VALID(userType.value) && userType.value === "MEMBER" ? (
            <Col md={IS_VALID(specificUser) && specificUser.length > 10 ? 12 : 6}>
              Specific Users: Total {specificUser ? specificUser.length : 0}&nbsp;
              {isSpecificUserFieldDisabled ? (
                popupMessage(
                  <i className="fa fa-info-circle"></i>,
                  "Card Type is already assigned."
                )
              ) : (
                ""
              )}
              <Select.Async
                placeholder="Select or Search..."
                multi={true}
                disabled={isSpecificUserFieldDisabled}
                value={specificUser}
                loadOptions={(input, callback) => loadOptions(input, callback, 'MemberDetail', ['memberId', 'name'], specificUserOptions)}
                onChange={(value) => setValue({ specificUser: value })}
                />
                <Row
                  style={{
                    ...space
                  }}
                  >
                  <Col
                    md={IS_VALID(specificUser) && specificUser.length > 10 ? 6 : 12}
                    mdOffset={IS_VALID(specificUser) && specificUser.length > 10 ? 3 : null}
                    >
                    <Button
                      style={{
                        width: "100%"
                      }}
                      disabled={isUploadingCSVFile || isSpecificUserFieldDisabled}
                      onClick={() => {
                        if (!isSpecificUserFieldDisabled) {
                          this.dropzoneRef.name = "specificUser";
                          this.dropzoneRef.open();
                        }
                      }}
                      >
                      {isUploadingCSVFile ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : (
                        "UPLOAD SPECIFIC USER CSV"
                      )}
                    </Button>
                    <Dropzone
                      accept=".csv, text/csv"
                      style={{ display: "none" }}
                      multiple={false}
                      ref={(ref) => { this.dropzoneRef = ref; }}
                      onDropAccepted={(acceptedArray) => {
                        uploadUserCSVFile(acceptedArray[0], this.dropzoneRef.name);
                      }}
                      />
                  </Col>
                </Row>
            </Col>
          ) : (
            ""
          )}
          <Col
            md={IS_VALID(blacklistedUser) && blacklistedUser.length > 10 ? 12 : 6}
            >
            Excluded Users: Total {blacklistedUser ? blacklistedUser.length : 0}
            <Select.Async
              placeholder="Select or Search..."
              multi={true}
              value={blacklistedUser}
              loadOptions={(input, callback) => loadOptions(input, callback, 'MemberDetail', ['memberId', 'name'], blacklistedUserOptions)}
              onChange={(value) => setValue({ blacklistedUser: value })}
              />
              <Row
                style={{
                  ...space
                }}
                >
                <Col
                  md={IS_VALID(blacklistedUser) && blacklistedUser.length > 10 ? 6 : 12}
                  mdOffset={IS_VALID(blacklistedUser) && blacklistedUser.length > 10 ? 3 : null}
                  >
                  <Button
                    style={{ width: "100%" }}
                    disabled={isUploadingCSVFile}
                    onClick={() => {
                      this.dropzoneRef.name = "blacklistedUser";
                      this.dropzoneRef.open();
                    }}
                    >
                    {isUploadingCSVFile ? (
                      <i className="fa fa-spinner fa-spin"></i>
                    ) : (
                      "UPLOAD EXCLUDED USER CSV"
                    )}
                  </Button>
                </Col>
              </Row>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/PendingNotification/FormContainer/Update.js